import * as React from 'react';
import { Flex, Input, InputProps } from '@chakra-ui/react';

import { UndoEdit } from '../../iconButtons/UndoEdit';
import { withConfirm } from '../withConfirm';
import { CustomFormControl, DirectionProp } from '../CustomFormControl';

interface IProps extends DirectionProp {
  value?: string;
  label?: string;
  id?: string;
  name?: string;
  subText?: string;
  inputHelperText?: string;
  errorText?: string;
  forwardedRef?: ((instance: HTMLInputElement | null) => void) | React.RefObject<HTMLInputElement> | null | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  canUndo?: boolean;
  onUndo?: () => void;
  size?: 'lg' | 'md' | 'sm';
  mb?: number | string;
  inputProps?: InputProps;
}

const YearInput: React.FC<IProps> = (props: IProps) => {
  const {
    value,
    label,
    id = 'year-input',
    name,
    subText,
    errorText,
    onBlur,
    onFocus,
    canUndo = false,
    onUndo,
    size = 'lg',
    mb = 0,
    direction,
    inputProps,
  } = props;

  const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    // disallow any non numeric keys
    const { value } = evt.currentTarget;

    if (!/^\d*$/.test(value)) {
      return false;
    }
    return props.onChange(evt);
  };

  return (
    <CustomFormControl
      id={id}
      controlProps={{
        isInvalid: !!errorText,
        mb,
      }}
      direction={direction}
      size={size}
      label={label}
      labelProps={{ htmlFor: `${id}-year-input-field` }}
      subLabel={subText}
      error={errorText}
    >
      <Flex gap={{ base: 2, lg: 4 }}>
        <Input
          key="year-input"
          name={name}
          id={`${id}-year-input-field`}
          data-selector={`${id}-year-input-field`}
          onChange={onChange}
          size={size}
          type="text"
          pattern="\d*"
          inputMode="numeric"
          value={value ? value : ''}
          maxLength={4}
          placeholder="YYYY"
          onBlur={onBlur}
          onFocus={onFocus}
          maxWidth="8rem"
          {...inputProps}
        />

        {canUndo ? <UndoEdit id={id} onUndo={onUndo} /> : null}
      </Flex>
    </CustomFormControl>
  );
};

const YearInputWithConfirm = withConfirm(YearInput);

export { YearInput, YearInputWithConfirm };
